<div [ngbPopover]="deletepopContent" placement="bottom" popoverClass="menuPopover" data-bs-toggle="dropdown"
  class="deleteSession  pointer" (click)="$event.stopPropagation()">
  <i class="sidebar__icon" [innerHTML]="ICONS.threeDotIcon | safeHtml"> </i>
</div>
<ng-template #deletepopContent>
  <div class="poplist">
    <button class="popMenu p-2" ngbDropdownItem (click)="deleteSession(chatId)">
      <i [innerHTML]="ICONS.deleteIcon | safeHtml"> </i>
      <span>Delete Chat</span>
    </button>
  </div>
</ng-template>